import BackgroundDynamic from '@activebrands/core-web/components/BackgroundDynamic';
import ReturnIframeElement from '@activebrands/core-web/components/ReturnIframe';
import { StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import { BackgroundOverlaysTypes } from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import { TransformedBackgroundTypes } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import type { ImageLoading } from '@activebrands/core-web/types/components/image';

interface ReturnIframeProps {
    src: string;
    backgrounds: TransformedBackgroundTypes[];
    sbEditable?: StoryblokEditable;
    backgroundOverlays: BackgroundOverlaysTypes;
    backgroundLoading?: ImageLoading;
}
const ReturnIframe = ({
    src = '',
    sbEditable,
    backgrounds,
    backgroundOverlays,
    backgroundLoading = 'lazy',
}: ReturnIframeProps) => {
    const [css] = useStyletron();

    return (
        <div
            className={css({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                width: '100%',
            })}
            {...sbEditable}
        >
            {backgrounds?.length > 0 && (
                <BackgroundDynamic
                    background={backgrounds}
                    backgroundOverlay={backgroundOverlays}
                    loading={backgroundLoading}
                />
            )}
            <ReturnIframeElement src={src} $style={{ backgroundColor: 'var(--color-bg-white)', padding: '32px' }} />
        </div>
    );
};

export default ReturnIframe;
